export default __webpack_public_path__ + "static/media/playlist.f86fb0c6.svg";